/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RapidWorks.PdfTemplates.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePdfBlockInput,
  GetApiPdfTemplatesV1BlocksParams,
  PagedResultOfPdfBlockDto,
  PdfBlockDetailDto,
  PdfBlockDto,
  PdfBlockUsageDto,
  ProblemDetails,
  UpdatePdfBlockInput
} from '../../models';

import { customInstance } from '../../../common/infrastructure/http/apiClient.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export type getApiPdfTemplatesV1BlocksResponse200TextPlain = {
  data: PagedResultOfPdfBlockDto;
  status: 200;
};

export type getApiPdfTemplatesV1BlocksResponse200ApplicationJson = {
  data: PagedResultOfPdfBlockDto;
  status: 200;
};

export type getApiPdfTemplatesV1BlocksResponse200TextJson = {
  data: PagedResultOfPdfBlockDto;
  status: 200;
};

export type getApiPdfTemplatesV1BlocksResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiPdfTemplatesV1BlocksResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiPdfTemplatesV1BlocksResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiPdfTemplatesV1BlocksResponseSuccess = (
  | getApiPdfTemplatesV1BlocksResponse200TextPlain
  | getApiPdfTemplatesV1BlocksResponse200ApplicationJson
  | getApiPdfTemplatesV1BlocksResponse200TextJson
) & {
  headers: Headers;
};
export type getApiPdfTemplatesV1BlocksResponseError = (
  | getApiPdfTemplatesV1BlocksResponse400TextPlain
  | getApiPdfTemplatesV1BlocksResponse400ApplicationJson
  | getApiPdfTemplatesV1BlocksResponse400TextJson
) & {
  headers: Headers;
};

export type getApiPdfTemplatesV1BlocksResponse = getApiPdfTemplatesV1BlocksResponseSuccess | getApiPdfTemplatesV1BlocksResponseError;

export const getGetApiPdfTemplatesV1BlocksUrl = (params?: GetApiPdfTemplatesV1BlocksParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pdf-templates/v1/blocks?${stringifiedParams}` : `/api/pdf-templates/v1/blocks`;
};

export const getApiPdfTemplatesV1Blocks = async (
  params?: GetApiPdfTemplatesV1BlocksParams,
  options?: Parameters<typeof customInstance>[1]
): Promise<getApiPdfTemplatesV1BlocksResponse> => {
  return customInstance<getApiPdfTemplatesV1BlocksResponse>(getGetApiPdfTemplatesV1BlocksUrl(params), {
    ...options,
    method: 'GET'
  });
};

export const getGetApiPdfTemplatesV1BlocksMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getApiPdfTemplatesV1Blocks>>,
    TError,
    { params?: GetApiPdfTemplatesV1BlocksParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getApiPdfTemplatesV1Blocks>>,
  TError,
  { params?: GetApiPdfTemplatesV1BlocksParams },
  TContext
> => {
  const mutationKey = ['getApiPdfTemplatesV1Blocks'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getApiPdfTemplatesV1Blocks>>,
    { params?: GetApiPdfTemplatesV1BlocksParams }
  > = (props) => {
    const { params } = props ?? {};

    return getApiPdfTemplatesV1Blocks(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetApiPdfTemplatesV1BlocksMutationResult = NonNullable<Awaited<ReturnType<typeof getApiPdfTemplatesV1Blocks>>>;

export type GetApiPdfTemplatesV1BlocksMutationError = ProblemDetails;

export const useGetApiPdfTemplatesV1Blocks = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getApiPdfTemplatesV1Blocks>>,
      TError,
      { params?: GetApiPdfTemplatesV1BlocksParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getApiPdfTemplatesV1Blocks>>,
  TError,
  { params?: GetApiPdfTemplatesV1BlocksParams },
  TContext
> => {
  return useMutation(getGetApiPdfTemplatesV1BlocksMutationOptions(options), queryClient);
};
export type postApiPdfTemplatesV1BlocksResponse201TextPlain = {
  data: PdfBlockDto;
  status: 201;
};

export type postApiPdfTemplatesV1BlocksResponse201ApplicationJson = {
  data: PdfBlockDto;
  status: 201;
};

export type postApiPdfTemplatesV1BlocksResponse201TextJson = {
  data: PdfBlockDto;
  status: 201;
};

export type postApiPdfTemplatesV1BlocksResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksResponseSuccess = (
  | postApiPdfTemplatesV1BlocksResponse201TextPlain
  | postApiPdfTemplatesV1BlocksResponse201ApplicationJson
  | postApiPdfTemplatesV1BlocksResponse201TextJson
) & {
  headers: Headers;
};
export type postApiPdfTemplatesV1BlocksResponseError = (
  | postApiPdfTemplatesV1BlocksResponse400TextPlain
  | postApiPdfTemplatesV1BlocksResponse400ApplicationJson
  | postApiPdfTemplatesV1BlocksResponse400TextJson
) & {
  headers: Headers;
};

export type postApiPdfTemplatesV1BlocksResponse = postApiPdfTemplatesV1BlocksResponseSuccess | postApiPdfTemplatesV1BlocksResponseError;

export const getPostApiPdfTemplatesV1BlocksUrl = () => {
  return `/api/pdf-templates/v1/blocks`;
};

export const postApiPdfTemplatesV1Blocks = async (
  createPdfBlockInput: CreatePdfBlockInput,
  options?: Parameters<typeof customInstance>[1]
): Promise<postApiPdfTemplatesV1BlocksResponse> => {
  return customInstance<postApiPdfTemplatesV1BlocksResponse>(getPostApiPdfTemplatesV1BlocksUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPdfBlockInput)
  });
};

export const getPostApiPdfTemplatesV1BlocksQueryKey = (createPdfBlockInput?: CreatePdfBlockInput) => {
  return ['POST', `/api/pdf-templates/v1/blocks`, createPdfBlockInput] as const;
};

export const getPostApiPdfTemplatesV1BlocksQueryOptions = <
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>,
  TError = ProblemDetails
>(
  createPdfBlockInput: CreatePdfBlockInput,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPostApiPdfTemplatesV1BlocksQueryKey(createPdfBlockInput);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>> = ({ signal }) =>
    postApiPdfTemplatesV1Blocks(createPdfBlockInput, { signal, ...requestOptions });

  return { queryKey, queryFn, staleTime: 120000, refetchOnWindowFocus: false, retry: 1, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostApiPdfTemplatesV1BlocksQueryResult = NonNullable<Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>>;
export type PostApiPdfTemplatesV1BlocksQueryError = ProblemDetails;

export function usePostApiPdfTemplatesV1Blocks<TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError = ProblemDetails>(
  createPdfBlockInput: CreatePdfBlockInput,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>,
          TError,
          Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostApiPdfTemplatesV1Blocks<TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError = ProblemDetails>(
  createPdfBlockInput: CreatePdfBlockInput,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>,
          TError,
          Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostApiPdfTemplatesV1Blocks<TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError = ProblemDetails>(
  createPdfBlockInput: CreatePdfBlockInput,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePostApiPdfTemplatesV1Blocks<TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError = ProblemDetails>(
  createPdfBlockInput: CreatePdfBlockInput,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1Blocks>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPostApiPdfTemplatesV1BlocksQueryOptions(createPdfBlockInput, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getPdfBlockByIdResponse200TextPlain = {
  data: PdfBlockDto;
  status: 200;
};

export type getPdfBlockByIdResponse200ApplicationJson = {
  data: PdfBlockDto;
  status: 200;
};

export type getPdfBlockByIdResponse200TextJson = {
  data: PdfBlockDto;
  status: 200;
};

export type getPdfBlockByIdResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type getPdfBlockByIdResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type getPdfBlockByIdResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type getPdfBlockByIdResponseSuccess = (
  | getPdfBlockByIdResponse200TextPlain
  | getPdfBlockByIdResponse200ApplicationJson
  | getPdfBlockByIdResponse200TextJson
) & {
  headers: Headers;
};
export type getPdfBlockByIdResponseError = (
  | getPdfBlockByIdResponse404TextPlain
  | getPdfBlockByIdResponse404ApplicationJson
  | getPdfBlockByIdResponse404TextJson
) & {
  headers: Headers;
};

export type getPdfBlockByIdResponse = getPdfBlockByIdResponseSuccess | getPdfBlockByIdResponseError;

export const getGetPdfBlockByIdUrl = (id: number) => {
  return `/api/pdf-templates/v1/blocks/${id}`;
};

export const getPdfBlockById = async (id: number, options?: Parameters<typeof customInstance>[1]): Promise<getPdfBlockByIdResponse> => {
  return customInstance<getPdfBlockByIdResponse>(getGetPdfBlockByIdUrl(id), {
    ...options,
    method: 'GET'
  });
};

export const getGetPdfBlockByIdMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getPdfBlockById>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof getPdfBlockById>>, TError, { id: number }, TContext> => {
  const mutationKey = ['getPdfBlockById'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPdfBlockById>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return getPdfBlockById(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPdfBlockByIdMutationResult = NonNullable<Awaited<ReturnType<typeof getPdfBlockById>>>;

export type GetPdfBlockByIdMutationError = ProblemDetails;

export const useGetPdfBlockById = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof getPdfBlockById>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof getPdfBlockById>>, TError, { id: number }, TContext> => {
  return useMutation(getGetPdfBlockByIdMutationOptions(options), queryClient);
};
export type putApiPdfTemplatesV1BlocksIdResponse204 = {
  data: void;
  status: 204;
};

export type putApiPdfTemplatesV1BlocksIdResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type putApiPdfTemplatesV1BlocksIdResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiPdfTemplatesV1BlocksIdResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiPdfTemplatesV1BlocksIdResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type putApiPdfTemplatesV1BlocksIdResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type putApiPdfTemplatesV1BlocksIdResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type putApiPdfTemplatesV1BlocksIdResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type putApiPdfTemplatesV1BlocksIdResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type putApiPdfTemplatesV1BlocksIdResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type putApiPdfTemplatesV1BlocksIdResponseSuccess = putApiPdfTemplatesV1BlocksIdResponse204 & {
  headers: Headers;
};
export type putApiPdfTemplatesV1BlocksIdResponseError = (
  | putApiPdfTemplatesV1BlocksIdResponse400TextPlain
  | putApiPdfTemplatesV1BlocksIdResponse400ApplicationJson
  | putApiPdfTemplatesV1BlocksIdResponse400TextJson
  | putApiPdfTemplatesV1BlocksIdResponse404TextPlain
  | putApiPdfTemplatesV1BlocksIdResponse404ApplicationJson
  | putApiPdfTemplatesV1BlocksIdResponse404TextJson
  | putApiPdfTemplatesV1BlocksIdResponse409TextPlain
  | putApiPdfTemplatesV1BlocksIdResponse409ApplicationJson
  | putApiPdfTemplatesV1BlocksIdResponse409TextJson
) & {
  headers: Headers;
};

export type putApiPdfTemplatesV1BlocksIdResponse = putApiPdfTemplatesV1BlocksIdResponseSuccess | putApiPdfTemplatesV1BlocksIdResponseError;

export const getPutApiPdfTemplatesV1BlocksIdUrl = (id: number) => {
  return `/api/pdf-templates/v1/blocks/${id}`;
};

export const putApiPdfTemplatesV1BlocksId = async (
  id: number,
  updatePdfBlockInput: UpdatePdfBlockInput,
  options?: Parameters<typeof customInstance>[1]
): Promise<putApiPdfTemplatesV1BlocksIdResponse> => {
  return customInstance<putApiPdfTemplatesV1BlocksIdResponse>(getPutApiPdfTemplatesV1BlocksIdUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePdfBlockInput)
  });
};

export const getPutApiPdfTemplatesV1BlocksIdQueryKey = (id: number, updatePdfBlockInput?: UpdatePdfBlockInput) => {
  return ['PUT', `/api/pdf-templates/v1/blocks/${id}`, updatePdfBlockInput] as const;
};

export const getPutApiPdfTemplatesV1BlocksIdQueryOptions = <
  TData = Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>,
  TError = ProblemDetails
>(
  id: number,
  updatePdfBlockInput: UpdatePdfBlockInput,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPutApiPdfTemplatesV1BlocksIdQueryKey(id, updatePdfBlockInput);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>> = ({ signal }) =>
    putApiPdfTemplatesV1BlocksId(id, updatePdfBlockInput, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    staleTime: 120000,
    refetchOnWindowFocus: false,
    retry: 1,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PutApiPdfTemplatesV1BlocksIdQueryResult = NonNullable<Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>>;
export type PutApiPdfTemplatesV1BlocksIdQueryError = ProblemDetails;

export function usePutApiPdfTemplatesV1BlocksId<TData = Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError = ProblemDetails>(
  id: number,
  updatePdfBlockInput: UpdatePdfBlockInput,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>,
          TError,
          Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePutApiPdfTemplatesV1BlocksId<TData = Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError = ProblemDetails>(
  id: number,
  updatePdfBlockInput: UpdatePdfBlockInput,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>,
          TError,
          Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePutApiPdfTemplatesV1BlocksId<TData = Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError = ProblemDetails>(
  id: number,
  updatePdfBlockInput: UpdatePdfBlockInput,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePutApiPdfTemplatesV1BlocksId<TData = Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError = ProblemDetails>(
  id: number,
  updatePdfBlockInput: UpdatePdfBlockInput,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof putApiPdfTemplatesV1BlocksId>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPutApiPdfTemplatesV1BlocksIdQueryOptions(id, updatePdfBlockInput, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiPdfTemplatesV1BlocksIdDetailResponse200TextPlain = {
  data: PdfBlockDetailDto;
  status: 200;
};

export type getApiPdfTemplatesV1BlocksIdDetailResponse200ApplicationJson = {
  data: PdfBlockDetailDto;
  status: 200;
};

export type getApiPdfTemplatesV1BlocksIdDetailResponse200TextJson = {
  data: PdfBlockDetailDto;
  status: 200;
};

export type getApiPdfTemplatesV1BlocksIdDetailResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type getApiPdfTemplatesV1BlocksIdDetailResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type getApiPdfTemplatesV1BlocksIdDetailResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type getApiPdfTemplatesV1BlocksIdDetailResponseSuccess = (
  | getApiPdfTemplatesV1BlocksIdDetailResponse200TextPlain
  | getApiPdfTemplatesV1BlocksIdDetailResponse200ApplicationJson
  | getApiPdfTemplatesV1BlocksIdDetailResponse200TextJson
) & {
  headers: Headers;
};
export type getApiPdfTemplatesV1BlocksIdDetailResponseError = (
  | getApiPdfTemplatesV1BlocksIdDetailResponse404TextPlain
  | getApiPdfTemplatesV1BlocksIdDetailResponse404ApplicationJson
  | getApiPdfTemplatesV1BlocksIdDetailResponse404TextJson
) & {
  headers: Headers;
};

export type getApiPdfTemplatesV1BlocksIdDetailResponse =
  | getApiPdfTemplatesV1BlocksIdDetailResponseSuccess
  | getApiPdfTemplatesV1BlocksIdDetailResponseError;

export const getGetApiPdfTemplatesV1BlocksIdDetailUrl = (id: number) => {
  return `/api/pdf-templates/v1/blocks/${id}/detail`;
};

export const getApiPdfTemplatesV1BlocksIdDetail = async (
  id: number,
  options?: Parameters<typeof customInstance>[1]
): Promise<getApiPdfTemplatesV1BlocksIdDetailResponse> => {
  return customInstance<getApiPdfTemplatesV1BlocksIdDetailResponse>(getGetApiPdfTemplatesV1BlocksIdDetailUrl(id), {
    ...options,
    method: 'GET'
  });
};

export const getGetApiPdfTemplatesV1BlocksIdDetailMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdDetail>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdDetail>>, TError, { id: number }, TContext> => {
  const mutationKey = ['getApiPdfTemplatesV1BlocksIdDetail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdDetail>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return getApiPdfTemplatesV1BlocksIdDetail(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetApiPdfTemplatesV1BlocksIdDetailMutationResult = NonNullable<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdDetail>>>;

export type GetApiPdfTemplatesV1BlocksIdDetailMutationError = ProblemDetails;

export const useGetApiPdfTemplatesV1BlocksIdDetail = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdDetail>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdDetail>>, TError, { id: number }, TContext> => {
  return useMutation(getGetApiPdfTemplatesV1BlocksIdDetailMutationOptions(options), queryClient);
};
export type postApiPdfTemplatesV1BlocksIdDuplicateResponse201TextPlain = {
  data: PdfBlockDto;
  status: 201;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse201ApplicationJson = {
  data: PdfBlockDto;
  status: 201;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse201TextJson = {
  data: PdfBlockDto;
  status: 201;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponseSuccess = (
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse201TextPlain
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse201ApplicationJson
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse201TextJson
) & {
  headers: Headers;
};
export type postApiPdfTemplatesV1BlocksIdDuplicateResponseError = (
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse400TextPlain
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse400ApplicationJson
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse400TextJson
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse404TextPlain
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse404ApplicationJson
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse404TextJson
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse409TextPlain
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse409ApplicationJson
  | postApiPdfTemplatesV1BlocksIdDuplicateResponse409TextJson
) & {
  headers: Headers;
};

export type postApiPdfTemplatesV1BlocksIdDuplicateResponse =
  | postApiPdfTemplatesV1BlocksIdDuplicateResponseSuccess
  | postApiPdfTemplatesV1BlocksIdDuplicateResponseError;

export const getPostApiPdfTemplatesV1BlocksIdDuplicateUrl = (id: number) => {
  return `/api/pdf-templates/v1/blocks/${id}/duplicate`;
};

export const postApiPdfTemplatesV1BlocksIdDuplicate = async (
  id: number,
  options?: Parameters<typeof customInstance>[1]
): Promise<postApiPdfTemplatesV1BlocksIdDuplicateResponse> => {
  return customInstance<postApiPdfTemplatesV1BlocksIdDuplicateResponse>(getPostApiPdfTemplatesV1BlocksIdDuplicateUrl(id), {
    ...options,
    method: 'POST'
  });
};

export const getPostApiPdfTemplatesV1BlocksIdDuplicateQueryKey = (id: number) => {
  return ['POST', `/api/pdf-templates/v1/blocks/${id}/duplicate`] as const;
};

export const getPostApiPdfTemplatesV1BlocksIdDuplicateQueryOptions = <
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPostApiPdfTemplatesV1BlocksIdDuplicateQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>> = ({ signal }) =>
    postApiPdfTemplatesV1BlocksIdDuplicate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    staleTime: 120000,
    refetchOnWindowFocus: false,
    retry: 1,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PostApiPdfTemplatesV1BlocksIdDuplicateQueryResult = NonNullable<
  Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>
>;
export type PostApiPdfTemplatesV1BlocksIdDuplicateQueryError = ProblemDetails;

export function usePostApiPdfTemplatesV1BlocksIdDuplicate<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>,
  TError = ProblemDetails
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>,
          TError,
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostApiPdfTemplatesV1BlocksIdDuplicate<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>,
          TError,
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostApiPdfTemplatesV1BlocksIdDuplicate<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePostApiPdfTemplatesV1BlocksIdDuplicate<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdDuplicate>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPostApiPdfTemplatesV1BlocksIdDuplicateQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type postApiPdfTemplatesV1BlocksIdArchiveResponse204 = {
  data: void;
  status: 204;
};

export type postApiPdfTemplatesV1BlocksIdArchiveResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdArchiveResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdArchiveResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdArchiveResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdArchiveResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdArchiveResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdArchiveResponseSuccess = postApiPdfTemplatesV1BlocksIdArchiveResponse204 & {
  headers: Headers;
};
export type postApiPdfTemplatesV1BlocksIdArchiveResponseError = (
  | postApiPdfTemplatesV1BlocksIdArchiveResponse404TextPlain
  | postApiPdfTemplatesV1BlocksIdArchiveResponse404ApplicationJson
  | postApiPdfTemplatesV1BlocksIdArchiveResponse404TextJson
  | postApiPdfTemplatesV1BlocksIdArchiveResponse409TextPlain
  | postApiPdfTemplatesV1BlocksIdArchiveResponse409ApplicationJson
  | postApiPdfTemplatesV1BlocksIdArchiveResponse409TextJson
) & {
  headers: Headers;
};

export type postApiPdfTemplatesV1BlocksIdArchiveResponse =
  | postApiPdfTemplatesV1BlocksIdArchiveResponseSuccess
  | postApiPdfTemplatesV1BlocksIdArchiveResponseError;

export const getPostApiPdfTemplatesV1BlocksIdArchiveUrl = (id: number) => {
  return `/api/pdf-templates/v1/blocks/${id}/archive`;
};

export const postApiPdfTemplatesV1BlocksIdArchive = async (
  id: number,
  options?: Parameters<typeof customInstance>[1]
): Promise<postApiPdfTemplatesV1BlocksIdArchiveResponse> => {
  return customInstance<postApiPdfTemplatesV1BlocksIdArchiveResponse>(getPostApiPdfTemplatesV1BlocksIdArchiveUrl(id), {
    ...options,
    method: 'POST'
  });
};

export const getPostApiPdfTemplatesV1BlocksIdArchiveQueryKey = (id: number) => {
  return ['POST', `/api/pdf-templates/v1/blocks/${id}/archive`] as const;
};

export const getPostApiPdfTemplatesV1BlocksIdArchiveQueryOptions = <
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPostApiPdfTemplatesV1BlocksIdArchiveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>> = ({ signal }) =>
    postApiPdfTemplatesV1BlocksIdArchive(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    staleTime: 120000,
    refetchOnWindowFocus: false,
    retry: 1,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PostApiPdfTemplatesV1BlocksIdArchiveQueryResult = NonNullable<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>>;
export type PostApiPdfTemplatesV1BlocksIdArchiveQueryError = ProblemDetails;

export function usePostApiPdfTemplatesV1BlocksIdArchive<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>,
  TError = ProblemDetails
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>,
          TError,
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostApiPdfTemplatesV1BlocksIdArchive<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>,
          TError,
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostApiPdfTemplatesV1BlocksIdArchive<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePostApiPdfTemplatesV1BlocksIdArchive<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdArchive>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPostApiPdfTemplatesV1BlocksIdArchiveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse204 = {
  data: void;
  status: 204;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponseSuccess = postApiPdfTemplatesV1BlocksIdUnarchiveResponse204 & {
  headers: Headers;
};
export type postApiPdfTemplatesV1BlocksIdUnarchiveResponseError = (
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse400TextPlain
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse400ApplicationJson
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse400TextJson
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse404TextPlain
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse404ApplicationJson
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse404TextJson
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse409TextPlain
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse409ApplicationJson
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponse409TextJson
) & {
  headers: Headers;
};

export type postApiPdfTemplatesV1BlocksIdUnarchiveResponse =
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponseSuccess
  | postApiPdfTemplatesV1BlocksIdUnarchiveResponseError;

export const getPostApiPdfTemplatesV1BlocksIdUnarchiveUrl = (id: number) => {
  return `/api/pdf-templates/v1/blocks/${id}/unarchive`;
};

export const postApiPdfTemplatesV1BlocksIdUnarchive = async (
  id: number,
  options?: Parameters<typeof customInstance>[1]
): Promise<postApiPdfTemplatesV1BlocksIdUnarchiveResponse> => {
  return customInstance<postApiPdfTemplatesV1BlocksIdUnarchiveResponse>(getPostApiPdfTemplatesV1BlocksIdUnarchiveUrl(id), {
    ...options,
    method: 'POST'
  });
};

export const getPostApiPdfTemplatesV1BlocksIdUnarchiveQueryKey = (id: number) => {
  return ['POST', `/api/pdf-templates/v1/blocks/${id}/unarchive`] as const;
};

export const getPostApiPdfTemplatesV1BlocksIdUnarchiveQueryOptions = <
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPostApiPdfTemplatesV1BlocksIdUnarchiveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>> = ({ signal }) =>
    postApiPdfTemplatesV1BlocksIdUnarchive(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    staleTime: 120000,
    refetchOnWindowFocus: false,
    retry: 1,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PostApiPdfTemplatesV1BlocksIdUnarchiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>
>;
export type PostApiPdfTemplatesV1BlocksIdUnarchiveQueryError = ProblemDetails;

export function usePostApiPdfTemplatesV1BlocksIdUnarchive<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>,
  TError = ProblemDetails
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>,
          TError,
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostApiPdfTemplatesV1BlocksIdUnarchive<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>,
          TError,
          Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostApiPdfTemplatesV1BlocksIdUnarchive<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePostApiPdfTemplatesV1BlocksIdUnarchive<
  TData = Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>,
  TError = ProblemDetails
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postApiPdfTemplatesV1BlocksIdUnarchive>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPostApiPdfTemplatesV1BlocksIdUnarchiveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiPdfTemplatesV1BlocksIdUsagesResponse200TextPlain = {
  data: PdfBlockUsageDto[];
  status: 200;
};

export type getApiPdfTemplatesV1BlocksIdUsagesResponse200ApplicationJson = {
  data: PdfBlockUsageDto[];
  status: 200;
};

export type getApiPdfTemplatesV1BlocksIdUsagesResponse200TextJson = {
  data: PdfBlockUsageDto[];
  status: 200;
};

export type getApiPdfTemplatesV1BlocksIdUsagesResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type getApiPdfTemplatesV1BlocksIdUsagesResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type getApiPdfTemplatesV1BlocksIdUsagesResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type getApiPdfTemplatesV1BlocksIdUsagesResponseSuccess = (
  | getApiPdfTemplatesV1BlocksIdUsagesResponse200TextPlain
  | getApiPdfTemplatesV1BlocksIdUsagesResponse200ApplicationJson
  | getApiPdfTemplatesV1BlocksIdUsagesResponse200TextJson
) & {
  headers: Headers;
};
export type getApiPdfTemplatesV1BlocksIdUsagesResponseError = (
  | getApiPdfTemplatesV1BlocksIdUsagesResponse404TextPlain
  | getApiPdfTemplatesV1BlocksIdUsagesResponse404ApplicationJson
  | getApiPdfTemplatesV1BlocksIdUsagesResponse404TextJson
) & {
  headers: Headers;
};

export type getApiPdfTemplatesV1BlocksIdUsagesResponse =
  | getApiPdfTemplatesV1BlocksIdUsagesResponseSuccess
  | getApiPdfTemplatesV1BlocksIdUsagesResponseError;

export const getGetApiPdfTemplatesV1BlocksIdUsagesUrl = (id: number) => {
  return `/api/pdf-templates/v1/blocks/${id}/usages`;
};

export const getApiPdfTemplatesV1BlocksIdUsages = async (
  id: number,
  options?: Parameters<typeof customInstance>[1]
): Promise<getApiPdfTemplatesV1BlocksIdUsagesResponse> => {
  return customInstance<getApiPdfTemplatesV1BlocksIdUsagesResponse>(getGetApiPdfTemplatesV1BlocksIdUsagesUrl(id), {
    ...options,
    method: 'GET'
  });
};

export const getGetApiPdfTemplatesV1BlocksIdUsagesMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdUsages>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdUsages>>, TError, { id: number }, TContext> => {
  const mutationKey = ['getApiPdfTemplatesV1BlocksIdUsages'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdUsages>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return getApiPdfTemplatesV1BlocksIdUsages(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetApiPdfTemplatesV1BlocksIdUsagesMutationResult = NonNullable<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdUsages>>>;

export type GetApiPdfTemplatesV1BlocksIdUsagesMutationError = ProblemDetails;

export const useGetApiPdfTemplatesV1BlocksIdUsages = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdUsages>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof getApiPdfTemplatesV1BlocksIdUsages>>, TError, { id: number }, TContext> => {
  return useMutation(getGetApiPdfTemplatesV1BlocksIdUsagesMutationOptions(options), queryClient);
};
